/* Country */
const countryDE: string = 'DE';
const countryES: string = 'ES';
const countryGB: string = 'GB';
const countryUS: string = 'US';

const countryDefault: string = countryDE;

const countryFallback: string = countryUS;

/*
 * Export functions.
 */
export {
    countryDE,
    countryES,
    countryGB,
    countryUS,
    countryDefault,
    countryFallback
}
